import apiHelper from '../utils/apiHelper';

export const eventsService = {
    // Get all events from SharePoint
    getAllEvents: async () => {
        try {
            const response = await apiHelper.get('/api/graph/events');
            return response.data || [];
        } catch (error) {
            console.error('Error fetching events:', error);
            throw error;
        }
    },

    // Create a new event
    createEvent: async (eventData, userName) => {
        try {
            // Map frontend field names to SharePoint field names (based on schema)
            const fields = {
                // Title is optional (Required="FALSE" in schema)
                Title: eventData.Title || null,
                
                // Core event fields
                EventDescription_x002f_Narrative: eventData.EventDescription_x002f_Narrative || null,
                EventDate: eventData.EventDate || null,
                StartTime: eventData.StartTime || null,
                EndTime: eventData.EndTime || null,
                EventLocation: eventData.EventLocation || null,
                
                // Choice fields
                EventCategory: eventData.EventCategory || null,
                InPerson_x002f_Virtual: eventData.InPerson_x002f_Virtual || null,
                // Multi-choice field - convert comma-separated string to array for SharePoint
                Topics: eventData.Topics ? 
                    (typeof eventData.Topics === 'string' ? 
                        eventData.Topics.split(',').map(t => t.trim()).filter(t => t) : 
                        eventData.Topics
                    ) : null,
                
                // Text fields
                Speakers: eventData.Speakers || null,
                Agenda: eventData.Agenda || null,
                EventSponsors: eventData.EventSponsors || eventData.Sponsors || null,
                RegistrationLink: eventData.RegistrationLink || null,
                AgendaLink: eventData.AgendaLink || null,
                ImageLink: eventData.ImageLink || null,
                CRMLink: eventData.CRMLink || null,
                
                // Number fields
                NumberOfAtendees: eventData.NumberOfAtendees || null, // Note: typo in SP field name
                NumberofRegistrations: eventData.NumberofRegistrations || null,
                
                // Collateral fields
                VideoCollateral: eventData.VideoCollateral || null,
                AudioCollateral: eventData.AudioCollateral || null,
                FileCollateral: eventData.FileCollateral || null,
                EventSurvey: eventData.EventSurvey || null,
                
                // Boolean fields (default to true per schema)
                CollateralPublishFlag: eventData.CollateralPublishFlag !== false,
                PublishFlag: eventData.PublishFlag !== false,
                
                // Auto-populated fields
                EventMonth: eventData.EventMonth || null,
                
                // Social media fields
                SocialMediaPostLinkedIn: eventData.SocialMediaPostLinkedIn || null,
                SocialMediaPostTwitterX: eventData.SocialMediaPostTwitterX || null,
                SocialMediaPostFacebook: eventData.SocialMediaPostFacebook || null
            };

            // Send to SharePoint
            const response = await apiHelper.post('/api/graph/addEvent', fields);
            return response;
        } catch (error) {
            console.error('Error creating event:', error);
            throw error;
        }
    },

    // Update an existing event
    updateEvent: async (eventId, eventData, userName) => {
        try {
            // Map frontend field names to SharePoint field names (same as create)
            const fields = {
                // Title is optional (Required="FALSE" in schema)
                Title: eventData.Title || null,
                
                // Core event fields
                EventDescription_x002f_Narrative: eventData.EventDescription_x002f_Narrative || null,
                EventDate: eventData.EventDate || null,
                StartTime: eventData.StartTime || null,
                EndTime: eventData.EndTime || null,
                EventLocation: eventData.EventLocation || null,
                
                // Choice fields
                EventCategory: eventData.EventCategory || null,
                InPerson_x002f_Virtual: eventData.InPerson_x002f_Virtual || null,
                // Multi-choice field - convert comma-separated string to array for SharePoint
                Topics: eventData.Topics ? 
                    (typeof eventData.Topics === 'string' ? 
                        eventData.Topics.split(',').map(t => t.trim()).filter(t => t) : 
                        eventData.Topics
                    ) : null,
                
                // Text fields
                Speakers: eventData.Speakers || null,
                Agenda: eventData.Agenda || null,
                EventSponsors: eventData.EventSponsors || eventData.Sponsors || null,
                RegistrationLink: eventData.RegistrationLink || null,
                AgendaLink: eventData.AgendaLink || null,
                ImageLink: eventData.ImageLink || null,
                CRMLink: eventData.CRMLink || null,
                
                // Number fields
                NumberOfAtendees: eventData.NumberOfAtendees || null,
                NumberofRegistrations: eventData.NumberofRegistrations || null,
                
                // Collateral fields
                VideoCollateral: eventData.VideoCollateral || null,
                AudioCollateral: eventData.AudioCollateral || null,
                FileCollateral: eventData.FileCollateral || null,
                EventSurvey: eventData.EventSurvey || null,
                
                // Boolean fields (preserve existing values)
                CollateralPublishFlag: eventData.CollateralPublishFlag !== false,
                PublishFlag: eventData.PublishFlag !== false,
                
                // Auto-populated fields
                EventMonth: eventData.EventMonth || null,
                
                // Social media fields
                SocialMediaPostLinkedIn: eventData.SocialMediaPostLinkedIn || null,
                SocialMediaPostTwitterX: eventData.SocialMediaPostTwitterX || null,
                SocialMediaPostFacebook: eventData.SocialMediaPostFacebook || null
                // Note: ModifiedByStaff field doesn't exist in SharePoint schema
            };

            const requestBody = {
                fields: fields
            };

            const response = await apiHelper.put(`/api/graph/updateEvent/${eventId}`, requestBody);
            return response.data;
        } catch (error) {
            console.error('Error updating event:', error);
            throw error;
        }
    },

    // Delete an event
    deleteEvent: async (eventId) => {
        try {
            const response = await apiHelper.delete(`/api/graph/deleteEvent/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting event:', error);
            throw new Error(error.response?.data?.message || 'Failed to delete event');
        }
    },

    // Get event choice fields (categories, types, etc.)
    getChoiceFields: async () => {
        try {
            const response = await apiHelper.get('/api/graph/getEventChoiceFields');
            return response.data;
        } catch (error) {
            console.error('Error fetching event choice fields:', error);
            throw error;
        }
    }
}; 